if (!customElements.get('sh-offer-code')) {
  customElements.define('sh-offer-code', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('button').addEventListener('click', async () => {
        const button = this.querySelector('button');
        try {
          await navigator.clipboard.writeText('ROUTINE10');
          button.textContent = button.dataset.copied;
        } catch {
          this.querySelector('[aria-live]').textContent = 'ROUTINE10';
        }
      });
    }
  });
}
if (!customElements.get('sh-duo-offer')) {
  customElements.define('sh-duo-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.select = this.querySelector('[data-duo-select]');
      this.button = this.querySelector('[data-duo-add]');
      this.error = this.querySelector('.sh-duo-error');
      this.variants = JSON.parse(this.querySelector('[data-duo-variants]').textContent);
      this.scope = this.closest('.product-details') || this.closest('main');
      this.abort = new AbortController();
      this.select.addEventListener('change', () => this.update(), {signal:this.abort.signal});
      this.scope.addEventListener('change', () => requestAnimationFrame(() => this.update()), {signal:this.abort.signal});
      this.button.addEventListener('pointerenter', () => this.update(), {signal:this.abort.signal});
      this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    currentVariant() {
      const input = this.scope.querySelector('product-form-component form [name="id"]');
      const id = input?.value || new URL(location.href).searchParams.get('variant') || this.dataset.primaryId;
      return this.variants.find(v => String(v.id) === String(id)) || this.variants[0];
    }
    money(amount) {
      return new Intl.NumberFormat(this.dataset.locale || 'fr', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(amount / 100);
    }
    update() {
      const primary = this.currentVariant();
      const option = this.select.selectedOptions[0];
      if (!primary || !option) { this.button.disabled = true; return; }
      const price = Number(option.dataset.price);
      const reduced = price - Math.floor(price * 0.15);
      this.querySelector('[data-care-price]').textContent = this.money(reduced);
      this.querySelector('[data-care-before]').textContent = this.money(price);
      this.querySelector('[data-care-saving]').textContent = this.money(price - reduced);
      this.querySelector('[data-duo-total]').textContent = this.money(primary.price + reduced);
      this.querySelector('[data-duo-button-label]').textContent = primary.available ? this.dataset.button : this.dataset.unavailable;
      this.button.disabled = this.busy || !primary.available;
      const image = this.querySelector('.sh-duo-img');
      if (image && image.getAttribute('src') !== option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
        image.alt = option.dataset.title;
      }
      this.querySelector('[data-care-link]').href = option.dataset.url;
    }
    async add() {
      if (this.busy) return;
      this.update();
      const primary = this.currentVariant();
      if (this.button.disabled || !primary?.available) return;
      this.busy = true;
      this.button.disabled = true;
      this.error.textContent = '';
      this.querySelector('[data-duo-button-label]').textContent = this.dataset.pending;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:primary.id,quantity:1},{id:Number(this.select.value),quantity:1}]})
        });
        if (!response.ok) throw new Error('cart');
        await response.json();
        location.assign(this.dataset.cartUrl);
      } catch {
        this.error.textContent = this.dataset.error;
        this.busy = false;
        this.update();
      }
    }
  });
}
